import "./verification-info.scss";
import useDesktopChecker from "hooks/useDesktopChecker";
import voaInfoImage from "assets/images/voaInfoImage.svg";
import boltIconImage from "assets/images/boltIconImage.svg";
import schieldIconImage from "assets/images/schieldIconImage.svg";
import documentIconImage from "assets/images/documentIconImage.svg";
import { VerificationType } from "pages/online-verification/verificationService";

interface VerificationInfoProps {
  verificationType: VerificationType;
}

const VerificationInfo: React.FC<VerificationInfoProps> = ({ verificationType }: VerificationInfoProps) => {
  const isDesktop = useDesktopChecker();

  const headingText =
    verificationType === "VOA" ? "Sharing your assets helps us personalize options" : "Sharing your income helps us personalize options";
  return (
    <div className="voaInfo-wrapper">
      <h1>{headingText}</h1>
      <div className="info">
        <div className="details-container">
          <div className="details">
            <img src={boltIconImage} alt="bullet icon" />
            <div className="point">
              <span>Custom options</span>
              <p>Loan products tailored for your needs</p>
            </div>
          </div>
          <div className="details">
            <img src={schieldIconImage} alt="bullet icon" />
            <div className="point">
              <span>Keep your data safe</span>
              <p>Best in class encryption</p>
            </div>
          </div>
          <div className="details">
            <img src={documentIconImage} alt="bullet icon" />
            <div className="point">
              <span>Smooth, hassle-free process</span>
              <p>{verificationType === "VOA" ? "Easy to provide assets information" : "Easy to provide income information"}</p>
            </div>
          </div>
        </div>
        {isDesktop && <img src={voaInfoImage} alt="account-check-image" className="accountCheckImage" />}
      </div>
    </div>
  );
};

export default VerificationInfo;
